import React, { FunctionComponent } from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const ColorPaletteIcon: FunctionComponent<SvgIconProps> = (props) => {
	return (
		<SvgIcon
			height="12"
			viewBox="0 0 12 12"
			width="12"
			{...props}
		>
			<path d="M6 0C2.68667 0 0 2.68667 0 6C0 9.31333 2.68667 12 6 12C6.55333 12 7 11.5533 7 11C7 10.74 6.90333 10.5067 6.74 10.33C6.58333 10.1533 6.49 9.92333 6.49 9.66667C6.49 9.11333 6.93667 8.66667 7.49 8.66667H8.66667C10.5067 8.66667 12 7.17333 12 5.33333C12 2.38667 9.31333 0 6 0ZM2.33333 6C1.78 6 1.33333 5.55333 1.33333 5C1.33333 4.44667 1.78 4 2.33333 4C2.88667 4 3.33333 4.44667 3.33333 5C3.33333 5.55333 2.88667 6 2.33333 6ZM4.33333 3.33333C3.78 3.33333 3.33333 2.88667 3.33333 2.33333C3.33333 1.78 3.78 1.33333 4.33333 1.33333C4.88667 1.33333 5.33333 1.78 5.33333 2.33333C5.33333 2.88667 4.88667 3.33333 4.33333 3.33333ZM7.66667 3.33333C7.11333 3.33333 6.66667 2.88667 6.66667 2.33333C6.66667 1.78 7.11333 1.33333 7.66667 1.33333C8.22 1.33333 8.66667 1.78 8.66667 2.33333C8.66667 2.88667 8.22 3.33333 7.66667 3.33333ZM9.66667 6C9.11333 6 8.66667 5.55333 8.66667 5C8.66667 4.44667 9.11333 4 9.66667 4C10.22 4 10.6667 4.44667 10.6667 5C10.6667 5.55333 10.22 6 9.66667 6Z" fill="#79818F" />
		</SvgIcon>
	);
};

export default ColorPaletteIcon;
